<div height="auto" width="auto">
    <canvas #graphCanvas [height]="height" [width]="width" ></canvas>
    <!-- <image [height]="height" [width]="width" [href]=imageSource *ngIf="isScale"></image> -->
</div>